import { 
    IRegistrationService, 
    ProgressService 
} from 'phoenix/services';
import { TrackingService } from 'sharebase/services/trackingService';

const template = require('./login-register.template');
const TOAST_POSITION = 'bottom right';
const TOAST_DELAY = 3000;

/**
 * @ngdoc directive
 * @name phoenix.login:pxLoginRegister
 * @module phoenix
 * @restrict E
 *
 * @description
 *
 * `pxLoginRegister` a view component of `pxLogin`
 * @param {string@} deploymentId Id of the deployment being register
 * @param {string@} authToken A temporary authentication token used to authorize the user for registration
 */
export function LoginRegisterDirective():ng.IDirective {
    return {
        restrict: 'E',
        controller: LoginRegisterController,
        controllerAs: 'vm',
        bindToController: true,
        template,
        scope: {
            deploymentId: '@',
            authToken: '@',
            errorMessage: '=?'
        }
    };
};

export class LoginRegisterController {
    static $inject = [
        '$state',
        '$timeout',
        '$mdToast',
        '$stateParams',
        'pxProgressService',
        'pxRegistrationService',
        'sbTrackingService',
        'gettextCatalog'
    ];

    // form bindings
    public displayName: string;
    public password: string = '';
    public confirmPassword: string = '';

    // directive inputs
    public deploymentId: string;
    public authToken: string;

    // local fields
    private errorMessage: string = '';
    private submitting: boolean = false;
    private loginRegisterForm: ng.IFormController;

    constructor(
        private $state, 
        private $timeout:ng.ITimeoutService, 
        private $mdToast,
        $stateParams, 
        private pxProgressService:ProgressService,
        private readonly registration:IRegistrationService,
        private readonly trackingService:TrackingService,
        private gettextCatalog:ng.gettext.gettextCatalog 
    ) {
        this.registration.validateRegistrationToken($stateParams.auth)
            .catch(() => $state.go('login', {
                errorMessage: gettextCatalog.getString('The registration link has expired')
            }))
    }

    public completeRegistration() {
        this.errorMessage = '';

        if (!this.loginRegisterForm.$valid) {
            return;
        }

        if (this.password !== this.confirmPassword) {
            this.errorMessage = this.gettextCatalog.getString("New passwords don't match");
        } else {
            this.trackingService.trackClick('Creating Customer Deployment Completed');
            this.isSubmitting(true);
            this.registration.validatePassword(this.password, this.authToken)
                .then((result) => {
                    if (result.Valid) {

                        this.pxProgressService.text = this.gettextCatalog.getString('Creating Customer Deployment...');
                        return this.registration.registerDeployment(this.deploymentId, this.authToken, this.displayName, this.password)
                            .then(() => true);

                    } else {
                        this.password = '';
                        this.confirmPassword = '';
                        this.errorMessage = result.Error;
                        this.isSubmitting(false);
                        return false;
                    }
                })
                .then((result) => {
                    if (result) {
                        this.showRegistrationSuccessMessage();
                        this.$state.go('login');
                    }
                })
                .catch((err) => {
                    if(err.status === 409) {
                        this.errorMessage = this.gettextCatalog.getString('The registration has been canceled because your system or your user has already been successfully registered.');
                    }
                    else {
                        this.errorMessage = this.gettextCatalog.getString('An unknown error has ocurred while processing your registration. Please contact ShareBase technical support.');
                    }
                })
                .finally(() => this.isSubmitting(false));
        }
    }

    private showRegistrationSuccessMessage() {
        this.$timeout(() => {
            this.$mdToast.show(
                this.$mdToast.simple()
                    .textContent(this.gettextCatalog.getString('Your account is now registered, please login to continue.'))
                    .position(TOAST_POSITION)
                    .hideDelay(TOAST_DELAY)
            );
        }, 0);
    }

    private isSubmitting(submitting: boolean) {
        if (submitting) {
            this.pxProgressService.backdrop = submitting;
        }
        this.pxProgressService.visible = submitting;
        this.submitting = submitting;
    }

}


// WEBPACK FOOTER //
// ./src/phoenix/components/login/login-register.component.ts